// Icono de plato de la marca: dibujado en SVG (dos círculos, un solo trazo).
// Hereda el color del texto (currentColor).
const LogoPlato = ({ tamano = 28, className = "" }) => (
  <svg
    className={className}
    width={tamano}
    height={tamano}
    viewBox="0 0 32 32"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.75"
    strokeLinecap="round"
    aria-hidden="true"
    focusable="false"
  >
    <circle cx="16" cy="16" r="13" />
    <circle cx="16" cy="16" r="8.25" />
  </svg>
);

export default LogoPlato;
